import React, { Component } from "react";
import { Link } from 'react-router-dom';

export default class Login extends Component {
  constructor(props){
    super(props);
    this.state = {
      username: '',
      password: ''
    }
  }

  updateUsername = (e) => {
    this.setState({username: e.target.value})
  }

  updatePassword = (e) => {
    this.setState({password: e.target.value})
  }

  render() {
    return (
      <div className="auth-wrapper">
      <div className="auth-inner">
      <form onSubmit={(e) => this.props.handleLogin(e, this.state.username, this.state.password)}>
          <h3>Sign In</h3>

      <div className="form-group">
        <label>Username</label>
        <input type="username" name="password" autoComplete="on" required className="form-control" placeholder="Enter username" value={this.state.username} onChange={this.updateUsername}/>
      </div>

      <div className="form-group">
        <label>Password</label>
        <input type="password" name="password" autoComplete="on" required className="form-control" placeholder="Enter password" value={this.state.password} onChange={this.updatePassword}/>
      </div>

      <div className="form-group">
        <div className="custom-control custom-checkbox" id="remember-me">
          <input type="checkbox" className="custom-control-input" id="customCheck1" />
          <label className="custom-control-label" htmlFor="customCheck1">&nbsp;Remember me</label>
        </div>
      </div>

      <button type="submit" id="form-button" className="btn btn-primary btn-block">Submit</button>               
        <p className="forgot-password text-right">Don't have an account?&nbsp;
          <Link to={"/sign-up"} id='form-link'>Sign Up</Link>
        </p>
      </form>
      </div>
      </div>
    );
  }
}